<template>
	<div class="partner-logos-block">
		<div class="block-title">
			{{ t.partnerLogosTitle }}
		</div>

		<div v-for="logo in logosToShow" :key="logo" class="logo" :style="{backgroundImage: 'url(/customer/images/partner-logos/' + logo}" />

		<div class="clearfix" />
	</div>
</template>
 
<script setup lang="ts">
import { computed, ref } from "vue";
import { shuffle } from "lodash-es"; 
import { useStore } from '@/js/stores/index';

const store = useStore()

const logos = ref([
	"amazon.svg",
	"circle-k.svg",
	"forum-cinemas.jpg",
	"uber.svg",
	"google-play.svg",
	"maxima.svg",
	"booking.com.svg",
])

// Computeds
const t = computed(() => store.translations)
const logosToShow = computed(() => shuffle(logos.value).slice(0, 6))
</script>
